import { render, staticRenderFns } from "./List-ExternalOrders.vue?vue&type=template&id=92e77dec"
import script from "./List-ExternalOrders.vue?vue&type=script&lang=js"
export * from "./List-ExternalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports